import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';
import $ from "jquery"


const OfflineBookingValidation = (serviceIds: any) => {
  const local_language = localStorage.getItem('lang')

  const schemaObject = serviceIds.reduce((accumulator: any, serviceId: any) => {
    accumulator[`name`] = yup.string()
      .required(local_language == "alb" ? ValidationMessageAlbanian.Field("") : ValidationMessage.Field('customer name'))
      .min(3, local_language == "alb" ? ValidationMessageAlbanian.MinLength('', 3) : ValidationMessage.MinLength('customer name', 3)),

      accumulator[`email`] = yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("email address") : ValidationMessage.Field("email address"))
        .email(local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS).trim(),



      accumulator[`phone_number`] = yup.string().required(local_language == "alb" ?
        ValidationMessageAlbanian.Field("Numri i telefonit") : ValidationMessage.Field("phone number"))
        .min(7, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER)
        .max(15, local_language == "alb" ? ValidationMessageAlbanian.PHONE_MAX_CHAR : ValidationMessage.PHONE_MAX_CHAR)
        .matches(/^[0-9]*$/, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER) // Allow only digits
        .test('valid-phone', local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE : ValidationMessage.VALID_PHONE, value => {
          if (!value) return true;
          if (/^0+$/.test(value)) {
            return false;
          }
          return true;
        }),

      accumulator[`slot_st_${serviceId}`] = yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni kohën e shërbimit.' : "Please select service time."),


      accumulator[`start_date`] = yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni një datë fillimi' : 'Please select a start date')

    accumulator[`price_${serviceId}`] = yup.string()
      .required(local_language == "alb" ? ValidationMessageAlbanian.Field("çmimi i shërbimit") : ValidationMessage.Field("service price"))
      .min(2, local_language == "alb" ? "Çmimi i shërbimit duhet të jetë të paktën 3 shifror" : "Service price must be at least 2 digits.")
      .matches(/^[1-9][0-9]{0,4}$/, 'Ju lutemi vendosni një çmim të vlefshëm me deri në 5 shifra')
      .test('min-value', 'Vlera minimale duhet të jetë së paku 2 shifrore.', value => parseInt(value, 10) >= 2),

      accumulator[`category_${serviceId}`] = yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni një kategori' : 'Please select a category');
    accumulator[`service_${serviceId}`] = yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni një shërbim' : 'Please select a service');

    accumulator[`duration_${serviceId}`] = yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni kohëzgjatjen e shërbimit' : "Please select duration."),


      accumulator[`selectedStaffMembers_${serviceId}`] = yup.string()
        .min(1, local_language == "alb" ? 'Asnjë anëtar i stafit nuk është shtuar ende.' : "No staff member added yet.")
        .required(local_language == "alb" ? 'Asnjë anëtar i stafit nuk është shtuar ende.' : "No staff member added yet.");
    return accumulator;
  }, {});
  return yup.object().shape(schemaObject);
};

export default OfflineBookingValidation;

